import { useBreakpoints, breakpointsPrimeFlex } from '@vueuse/core'

export const breakpointsValues = breakpointsPrimeFlex
export const breakpoints = useBreakpoints(breakpointsValues)

export const smAndLarger = breakpoints.greaterOrEqual('sm')
export const mdAndLarger = breakpoints.greaterOrEqual('md')
export const lgAndLarger = breakpoints.greaterOrEqual('lg')
export const xlAndLarger = breakpoints.greaterOrEqual('xl')
